import React from 'react';
import { ZapIcon, LockIcon, CheckCircleIcon, BanknoteIcon, GiftIcon } from 'lucide-react';
interface StackItemProps {
  emoji: string;
  label: string;
  value: string;
}
function StackItem({
  emoji,
  label,
  value
}: StackItemProps) {
  return <div className="flex items-center justify-between py-3 border-b border-white/10 last:border-b-0" data-id="element-458">
      <div className="flex items-center gap-3" data-id="element-459">
        <span className="text-xl" role="img" aria-hidden="true" data-id="element-460">
          {emoji}
        </span>
        <span className="font-sans text-white/90 text-sm sm:text-base" data-id="element-461">
          {label}
        </span>
      </div>
      <span className="font-sans text-white/40 text-sm whitespace-nowrap ml-4 line-through" data-id="element-462">
        {value}
      </span>
    </div>;
}
interface BonusItemProps {
  emoji: string;
  label: string;
  value: string;
  tag: string;
}
function BonusItem({
  emoji,
  label,
  value,
  tag
}: BonusItemProps) {
  return <div className="flex items-center justify-between py-3 border-b border-burnt/20 last:border-b-0 bg-burnt/10 -mx-6 sm:-mx-8 px-6 sm:px-8" data-id="element-463">
      <div className="flex items-center gap-3" data-id="element-464">
        <span className="text-xl" role="img" aria-hidden="true" data-id="element-465">
          {emoji}
        </span>
        <div className="flex items-center gap-2 flex-wrap" data-id="element-466">
          <span className="font-sans text-white font-semibold text-sm sm:text-base" data-id="element-467">
            {label}
          </span>
          <span className="bg-burnt text-white text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full flex items-center gap-1" data-id="element-468">
            <GiftIcon className="w-2.5 h-2.5" data-id="element-469" />
            {tag}
          </span>
        </div>
      </div>
      <div className="flex items-center gap-2 whitespace-nowrap ml-4" data-id="element-470">
        <span className="font-sans text-white/40 text-sm line-through" data-id="element-471">
          {value}
        </span>
        <span className="font-sans text-green-300 text-sm font-bold" data-id="element-472">FREE</span>
      </div>
    </div>;
}
export function OfferStack() {
  return <section className="bg-forest py-12 md:py-16 px-5" id="buy" data-id="element-473">
      <div className="max-w-2xl mx-auto" data-id="element-474">
        {/* Title */}
        <h2 className="font-serif text-white text-3xl md:text-4xl font-bold text-center mb-12 leading-tight" data-id="element-475">
          Everything You Get Today
        </h2>

        {/* Stack */}
        <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 sm:p-8 mb-10 border border-white/10 overflow-hidden" data-id="element-476">
          <StackItem emoji="📗" label="The 365 Garden Shield eBook" value="$47 value" data-id="element-477" />
          <StackItem emoji="📋" label="Frost-Night Emergency Checklist" value="$17 value" data-id="element-478" />
          <StackItem emoji="☀️" label="Summer Scorch Survival Protocol" value="$17 value" data-id="element-479" />
          <StackItem emoji="🌪️" label="Storm-Ready Garden Blueprint" value="$17 value" data-id="element-480" />
          <StackItem emoji="🌱" label="The 24-Hour Plant Recovery Plan" value="$17 value" data-id="element-481" />
          <StackItem emoji="📅" label="4 Seasonal One-Page Checklists" value="$27 value" data-id="element-482" />
          <BonusItem emoji="🛡️" label="The Pest-Proof Perimeter" value="$34 value" tag="FREE BONUS" data-id="element-483" />
          <BonusItem emoji="💬" label="Personal Garden Mentor Access" value="$54 value" tag="VIP BONUS" data-id="element-484" />
        </div>

        {/* Bundle Image */}
        <div className="relative max-w-sm mx-auto mb-8" data-id="element-485">
          <div className="absolute -top-3 -right-3 z-20 bg-burnt text-white rounded-full w-16 h-16 flex flex-col items-center justify-center shadow-lg border-2 border-forest transform rotate-12" data-id="element-486">
            <span className="text-[8px] font-bold uppercase leading-tight text-center font-sans" data-id="element-487">
              📱 Digital
              <br data-id="element-488" />
              Edition
            </span>
          </div>
          <img src="https://cdn.magicpatterns.com/uploads/cXpYSpFijbmSoyns7cEVEN/73d29d76-1a3e-42a5-b715-bad50d3442e8.png" alt="The Complete 365 Garden Shield Bundle — eBook, Pest-Proof Perimeter & Personal Mentor Access" className="w-full h-auto rounded-xl shadow-2xl" data-id="element-489" />
        </div>

        {/* Total */}
        <div className="text-center mb-8" data-id="element-490">
          <div className="flex items-center justify-center gap-3 mb-2" data-id="element-491">
            <span className="font-sans text-white/50 text-lg" data-id="element-492">
              Total Value:
            </span>
            <span className="font-sans text-white/50 text-lg line-through" data-id="element-493">
              $142
            </span>
          </div>
          <div className="flex items-center justify-center gap-3" data-id="element-494">
            <span className="font-sans text-white text-xl font-semibold" data-id="element-495">
              YOU PAY:
            </span>
            <span className="font-serif text-burnt-light text-5xl md:text-6xl font-bold" data-id="element-496">
              $6.37
            </span>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center" data-id="element-497">
          <a href="https://pay.hotmart.com/B105054698I?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="cta-heartbeat inline-block bg-red-600 hover:bg-red-700 text-white text-lg font-bold py-4 px-10 rounded-lg shadow-lg transition-colors duration-200 mb-5" data-id="element-498">
            YES! I Want To Protect My Garden — $6.37
          </a>

          {/* Gold Trust Badges */}
          <div className="flex flex-wrap items-center justify-center gap-3" data-id="element-499">
            <div className="flex items-center gap-1.5 bg-yellow-500/10 border border-yellow-500/30 rounded-full px-3 py-1" data-id="element-500">
              <ZapIcon className="w-3 h-3 text-yellow-400" data-id="element-501" />
              <span className="text-yellow-300 text-xs font-semibold font-sans" data-id="element-502">
                Instant Access
              </span>
            </div>
            <div className="flex items-center gap-1.5 bg-yellow-500/10 border border-yellow-500/30 rounded-full px-3 py-1" data-id="element-503">
              <LockIcon className="w-3 h-3 text-yellow-400" data-id="element-504" />
              <span className="text-yellow-300 text-xs font-semibold font-sans" data-id="element-505">
                Bank-Level Security
              </span>
            </div>
            <div className="flex items-center gap-1.5 bg-yellow-500/10 border border-yellow-500/30 rounded-full px-3 py-1" data-id="element-506">
              <CheckCircleIcon className="w-3 h-3 text-yellow-400" data-id="element-507" />
              <span className="text-yellow-300 text-xs font-semibold font-sans" data-id="element-508">
                7-Day Guarantee
              </span>
            </div>
            <div className="flex items-center gap-1.5 bg-yellow-500/10 border border-yellow-500/30 rounded-full px-3 py-1" data-id="element-509">
              <BanknoteIcon className="w-3 h-3 text-yellow-400" data-id="element-510" />
              <span className="text-yellow-300 text-xs font-semibold font-sans" data-id="element-511">
                One-Time Payment
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}